import React from 'react';

import SharedSignupFlowHeader from './SharedSignupFlowHeader';

const UserCreationSignupFlowHeader: React.FC = () => {
  return <SharedSignupFlowHeader splitStepsAt={['user_agreement']} />;
};

export default UserCreationSignupFlowHeader;
